export class OpenGraphMeta {
  constructor(tags) {
    this.tagKeys = ['url', 'siteName', 'title', 'description', 'image']
    Object.keys(tags).forEach(tag => {
      let meta = this.createTag(tags[tag])
      document.head.appendChild(meta)
      this[tag] = meta
    })
  }

  // update open-graph meta
  set tags({ defaults, current = {} }) {
    this.tagKeys.forEach(tag => {
      let content = current[tag] || defaults[tag]
      if (content) this[tag].setAttribute('content', content)
    })
  }

  // create the HTML node to be inserted
  createTag({ property, content = '' }) {
    let meta = document.createElement('meta')

    meta.setAttribute('property', `og:${property}`)
    meta.setAttribute('content', content)

    return meta
  }

  // add an open-graph meta tag
  addTag(tag) {
    let meta
    if (!tag.name || !tag.property || this[tag.name]) return;

    meta = this.createTag(tag)
    document.head.appendChild(meta)
    this[tag.name] = meta
  }
}



// WEBPACK FOOTER //
// ./src/plugins/meta-tags/OpenGraphMeta.js